import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

const PageHero = ({ eyebrow, title, italic, description, image, imagePosition = 'center center', breadcrumbs = [] }) => {
  return (
    <section className="relative">
      <div className="max-w-[1240px] mx-auto px-6 pt-6">
        <div className="relative rounded-[28px] overflow-hidden bg-neutral-100 min-h-[420px] lg:min-h-[480px] fade-up">
          {image ? (
            <>
              <img src={image} alt={title} className="absolute inset-0 w-full h-full object-cover" style={{ objectPosition: imagePosition }} loading="eager" />
              <div className="absolute inset-0 bg-gradient-to-r from-white/95 via-white/70 to-white/20" />
            </>
          ) : (
            <div className="absolute inset-0 bg-gradient-to-br from-neutral-50 to-neutral-100" />
          )}
          <div className="relative z-10 max-w-[640px] px-8 lg:px-14 py-14 lg:py-20">
            {breadcrumbs.length > 0 && (
              <nav className="flex items-center gap-1 text-[12px] text-neutral-600 mb-6">
                {breadcrumbs.map((b, i) => (
                  <span key={i} className="flex items-center gap-1">
                    {b.to ? (
                      <Link to={b.to} className="hover:text-neutral-900">{b.label}</Link>
                    ) : (
                      <span className="text-neutral-900 font-medium">{b.label}</span>
                    )}
                    {i < breadcrumbs.length - 1 && <ChevronRight size={12} />}
                  </span>
                ))}
              </nav>
            )}
            {eyebrow && (
              <span className="inline-flex items-center rounded-full border border-neutral-300 bg-white/70 backdrop-blur px-4 py-1.5 text-[12px] font-medium text-neutral-800">
                {eyebrow}
              </span>
            )}
            <h1 className="mt-6 text-[46px] lg:text-[64px] leading-[0.98] font-bold tracking-[-0.04em] text-neutral-900">
              {title}{' '}
              {italic && <span className="font-serif-italic font-normal">{italic}</span>}
            </h1>
            {description && (
              <p className="mt-5 max-w-lg text-[15px] leading-relaxed text-neutral-600">{description}</p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PageHero;
